/*
  Исковое заявление на вкладке «Приказ» - §6.4.5, вариант А макетов (выбран
  владельцем 07.10.2026): сведения об отменённом приказе, ниже деньги иска, суд и
  кнопка.

  До этого дня счёт после отмены приказа доходил до стадии «исковое
  производство» и там останавливался: заявление собирали вне системы.

  Блок виден, когда иск возможен: приказ отменён (или счёт уже в исковом
  производстве), либо долг дороже предела приказного производства и идёт иском
  сразу - тогда отменённого приказа нет, и блока сведений о нём тоже нет.
*/

import { Loading, Notice } from './Common.jsx'
import AssemblyClosedNote from './AssemblyClosedNote.jsx'
import CancelledOrderForm from './CancelledOrderForm.jsx'
import LawsuitBuild from './LawsuitBuild.jsx'
import useLawsuit from './useLawsuit.js'

const LAWSUIT_STAGES = ['order_cancelled', 'lawsuit']
const OPEN = { allowed: true, closedByTier: false }

export default function LawsuitPanel({ card, sections, sectionsError, assemble = OPEN, onDone }) {
  const visible = LAWSUIT_STAGES.includes(card.stage) || card.triage?.route === 'lawsuit'
  // Сведения иска сервер отдаёт только тому, кому разрешена сборка (строка 127): без права
  // форму не грузим, иначе блок открылся бы ошибкой вместо пояснения.
  const { form, error, reload } = useLawsuit(card.account_id, visible && assemble.allowed)

  if (!visible) return null
  if (!assemble.allowed) return assemble.closedByTier ? <AssemblyClosedNote /> : null
  if (error) return <Notice error={error} />
  if (!form) return <Loading what="Собираем сведения для иска" />

  function saved(message) {
    onDone(message, 'ok')
    reload()
  }

  return (
    <>
      {form.cancellation ? (
        <CancelledOrderForm
          accountId={card.account_id}
          facts={form.cancellation}
          feeHint={form.fee_by_calculation}
          onSaved={saved}
        />
      ) : null}
      <LawsuitBuild
        accountId={card.account_id}
        form={form}
        sections={sections}
        sectionsError={sectionsError}
        onDone={onDone}
      />
    </>
  )
}
